import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Container } from 'react-bootstrap'
// WHY? this is in fact not used here, but this import makes sure we have the
// window.digitalData object present in EVERY page. We need this for adobe analytics
// Do not remove this line
import digitalData from 'config/adobeAnalytics/digitalData'
import { Sentry } from 'config/libs/sentry'
import { AppRoutes } from 'config/router/Routes'
import { AppProvider } from 'context/AppContext'
import useAppDataInit from 'hooks/useAppDataInit'
import LoadingPage from 'features/Common/screens/LoadingPage'
import Migration from 'features/Common/screens/Migration'
import MarkingTooltip from 'features/Marking/components/MarkingTooltip'
import { GlobalModalProvider } from 'features/Modal/GlobalModal'
// import OnboardingTour from 'features/Onboarding/screens/OnboardingTour'
import './App.scss'

window.digitalData = digitalData

const App = () => {
  const isMigration = localStorage.getItem('dbMigration')
  if (!isMigration) {
    return <Migration />
  }

  const { loading } = useAppDataInit()

  if (loading) {
    return <LoadingPage />
  }

  return (
    <Container id='App' fluid className='app-container p-0'>
      <AppProvider>
        <GlobalModalProvider>
          <DndProvider backend={HTML5Backend}>
            <AppRoutes />
            {/* TODO: Onboarding has to be fixed
             <OnboardingTour /> */}
            <MarkingTooltip />
          </DndProvider>
        </GlobalModalProvider>
      </AppProvider>
    </Container>
  )
}

export default Sentry.withProfiler(App)
